// extracted by mini-css-extract-plugin
export var hidden = "_s8-0";